"use strict";

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var utils = require("../../screeners/utils");

var scale = ["0", "1", "2", "3", "4", "5"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var fnUsefulnessScaleResp = function fnUsefulnessScaleResp(n) {
  return n;
};

var difficultyOptions = ["Relationship issue (friend, family or partner)", "Financial stress", "Health issue (self or other)", "Work stress", "Study stress", "Job loss", "Personal mental health issue", "Lack of support or resources", "Traumatic or stressful life event", "Loneliness/isolation", "Caring for another", "Parenting", "Recent or upcoming major change or major decision", "Grief or loss", "Bullying", "Struggling with identity", "Pressure to perform", "Other"];
var surveyscreeners = [utils.screeners.WHO5, utils.screeners.ALLIANZ_STRESS];
var questions = (0, _screeners.expandscreeners)([_utils.screeners.ALLIANZ_WHO5, {
  extraText: "Over the past month,",
  batteryId: "WHO5",
  type: "multiSkip",
  meta: {
    answerLabel: "My challenges are...",
    skipLabel: "I have no challenges at work",
    responsePrefix: "My challenges are: ",
    noResponsePrefix: "I have no challenges at work"
  },
  prompt: "have any of the following <b>made it hard for you to function<br /> effectively?</b> (you can choose multiple options)",
  options: difficultyOptions
}, _utils.screeners.ALLIANZ_STRESS, {
  prompt: "How would you rate the Allianz Care Mental Wellbeing program overall?",
  extraText: "",
  type: "slider",
  options: scale,
  key: "npsUprise",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "ALLIANZ_PROGRESS"
}, {
  prompt: "How would you rate your experience with your coach?",
  extraText: "",
  type: "slider",
  options: scale,
  batteryId: "ALLIANZ_PROGRESS"
}, {
  prompt: "If we could change or improve anything about the program, what would it be?",
  extraText: "",
  meta: {
    answerLabel: "My feedback is..",
    summaryTitle: "Your action for Other was…",
    placeholder: ""
  },
  type: "textarea",
  optional: true,
  key: "magicWand",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "ALLIANZ_PROGRESS"
}]);

var analysis = function analysis(answers, bonus) {
  if (!answers) return null;
  var results = {};
  surveyscreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    var answer;
    if (screener === "ALLIANZ_STRESS") answer = answers["STRESS"] || answers["ALLIANZ_STRESS"];else answer = answers[screener];
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answer, screener); // answer: {WHO5: Array, STRESS: Array}

    filteredQuestions.forEach(function (q, i) {
      if (!q.key) return;
      results[q.key] = q.eval(answer[i]);
    });
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};